/** Accurate supplier-facing recovery copy (GE-013). */

export const INVITE_RECOVERY = {
  NO_INVITE_CREATED: 'No invitation was created. You can safely try again.',
  CUSTOMER_ADDED_EMAIL_FAILED:
    'The customer was added, but the email could not be sent. Resend invitation.',
  ALREADY_CONNECTED: 'This customer is already connected. Open their record.',
  OUTCOME_UNCLEAR:
    "We couldn't confirm the outcome yet. Check the invitation status before trying again.",
  RESEND_TOO_SOON: seconds => `Please wait ${seconds}s before resending again.`,
  RESEND_RECIPIENT_CONFIRM:
    'We will resend the invitation email to this address for the existing relationship. Changing the recipient or transferring ownership is not available here.',
  NEW_USER_RESEND_UNAVAILABLE:
    'A full email resend for new accounts is not available from here. Copy the follow-up message, or contact OMS support if you need help.',
  HISTORY_UNAVAILABLE:
    'Invitation history unavailable for this customer. Open their record, or contact OMS support if you need help recovering access.',
  SUPPORT_EMAIL: 'info@ordersmadesimple.com',
}

export const inviteSupportMailto = ({
  venueName,
  accountNumber,
  email,
} = {}) => {
  const subject = encodeURIComponent('Supplier invitation help')
  const lines = [
    'I need help with a customer invitation on the supplier portal.',
    venueName ? `Venue: ${venueName}` : null,
    accountNumber ? `Account number: ${accountNumber}` : null,
    email ? `Recipient: ${email}` : null,
    '',
    'Please advise on the next step.',
  ].filter(Boolean)
  const body = encodeURIComponent(lines.join('\n'))
  return `mailto:${INVITE_RECOVERY.SUPPORT_EMAIL}?subject=${subject}&body=${body}`
}
